import types from './types';
import viewTypes from '../view/types';
import deleteIn from 'components/connectedForm/utils/deleteIn';
import setIn from 'components/connectedForm/utils/setIn';
import getIn from 'components/connectedForm/utils/getIn';

const initialState = {
  appMenuHidden: false,
  appSidebarHidden: true,
  appSidebarId: null,
  appSidebarType: null,
  appSidebarMenu: false,
  isLoggedIn: false,
  unAuthorized: false,
  authAlert: null,
  redirectLogin: false,
  user: null,
  company: null,
  focusArea: 'Menu',
  autoFocus: false,
  actionEntities: [],
  jobMap: {},
  returnURL: null,
  redirectToLogin: false,
  menu: {},
};

function reducer(state = initialState, action = {}) {
  let actionEntities = {},
    expandedRows = state.expandedRows,
    user;
  switch (action.type) {
    case types.USER_SUCCESS:
      //TODO temp fix
      localStorage.setItem('timeOut', Date.now());
      user = action.response.systemUser || action.response;
      return {
        ...state,
        isLoggedIn: true,
        unAuthorized: false,
        user,
        fullUserDetails: action.response,
        redirectLogin: false,
        redirectToLogin: false,
        reload:
          state.applicationVersion &&
          action.response.applicationVersion &&
          state.applicationVersion !== action.response.applicationVersion,
        company: {
          ...state.company,
          id: action.response.currentCompany ? action.response.currentCompany.id : null,
          name: action.response.currentCompany ? action.response.currentCompany.name : null,
        },
        applicationVersion: action.response.applicationVersion
          ? action.response.applicationVersion
          : state.applicationVersion,
      };

    case types.MODAL_USER_SUCCESS:
      localStorage.setItem('timeOut', Date.now());
      user = action.response.systemUser || action.response;
      return {
        ...state,
        isLoggedIn: true,
        unAuthorized: false,
        user,
        redirectLogin: false,
        redirectToLogin: false,
        company: {
          ...state.company,
        },
      };

    case types.VERSION_SUCCESS:
      return {
        ...state,
        version: action.response,
      };

    case types.MENU_UPDATE_SUCCESS:
      return {
        ...state,
        menu: action.menu,
      };

    case types.PASSWORD_RESET_SUCCESS:
      const result = action.response;
      return {
        ...state,
        result: result,
        isLoggedIn: false,
        user: null,
        redirectLogin: true,
        authAlert: {
          ...state.authAlert,
          type: 'success',
          message: 'Your password has now been reset',
        },
      };

    case types.REQUEST_PASSWORD_RESET_SUCCESS:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
        redirectLogin: false,
        authAlert: {
          ...state.authAlert,
          type: 'success',
          message: 'Your password reset request has now been sent',
        },
      };

    case types.SWITCH_COMPANY_SUCCESS:
      return {
        ...state,
        company: action.systemCompany,
        user: {
          ...state.user,
          currentCompany: action.systemCompany,
        },
      };

    case types.USER_FAILURE:
    case types.PASSWORD_RESET_FAILURE:
    case types.REQUEST_PASSWORD_RESET_FAILURE:
    case types.LOGOUT_USER_FAILURE:
      return {
        ...state,
        redirectLogin: false,
        authAlert: {
          ...state.authAlert,
          type: 'error',
          message: action.error,
          violations: action.violations,
        },
      };

    case types.LOGOUT_USER_SUCCESS:
      import('client').then(({ client }) => {
        client.resetStore();
      });
      const message = action.message ? action.message : 'You are now logged out';
      return {
        ...initialState,
        isLoggedIn: false,
        unAuthorized: false,
        redirectToLogin: true,
        user: '',
        authAlert: {
          ...initialState.authAlert,
          type: 'success',
          message,
        },
      };

    case types.CLEAR_LOGIN:
      const clearMessage = action.message ? action.message : 'You have noe been logged in';
      return {
        ...state,
        isLoggedIn: true,
        unAuthorized: false,
        authAlert: {
          ...state.authAlert,
          type: 'success',
          message: clearMessage,
        },
      };

    case types.LOGIN_REDIRECT:
      const authmessage = action.message ? action.message : 'You have exceeded the idle timeout and been logged out';
      return {
        ...state,
        isLoggedIn: false,
        unAuthorized: true,
        authAlert: {
          ...state.authAlert,
          type: 'success',
          message: authmessage,
        },
      };

    case types.DISMISS_AUTH_ALERT:
      return {
        ...state,
        authAlert: null,
      };

    case types.TOGGLE_MENU:
      return {
        ...state,
        appMenuHidden: action.payload,
      };

    case types.TOGGLE_SIDEBAR:
      return {
        ...state,
        appSidebarHidden: action.hidden,
        appSidebarId: action.id,
        appSidebarType: action.entity,
        appSidebarMenu: state.appMenuHidden,
        appMenuHidden: action.hidden ? state.appSidebarMenu : true,
      };

    case types.TOGGLE_MAIL_SIDEBAR:
      return {
        ...state,
        mailItemId: action.id,
        mailItemTo: action.user,
        appSidebarHidden: action.hidden,
        appSidebarType: action.entity,
        appSidebarMenu: state.appMenuHidden,
        appMenuHidden: action.hidden ? state.appSidebarMenu : true,
      };

    case types.TOGGLE_FULL_SCREEN:
      return {
        ...state,
        fullScreen: action.payload,
      };

    case types.FOCUS_AREA:
      return {
        ...state,
        focusArea: action.area,
        autoFocus: action.autoFocus,
      };

    case viewTypes.SET_DEFAULT_VIEW_SUCCESS:
      user = action.response;

      return {
        ...state,
        user,
      };

    case types.SET_ACTION_ENTITIES:
      actionEntities = action.actionEntities ? action.actionEntities : {};

      return {
        ...state,
        actionEntities: { ...state.actionEntities, ...actionEntities },
      };

    case types.SET_EXPANDED_ROW:
      expandedRows = state.expandedRows || {};
      expandedRows[action.prefix] = expandedRows[action.prefix] || [];

      expandedRows[action.prefix][action.rowIndex] = {
        ...action.options,
        expanded: !expandedRows[action.prefix][action.rowIndex]?.expanded,
      };

      return {
        ...state,
        expandedRows,
      };

    case types.SET_EXPANDED_ROWS:
      expandedRows = action.expandedRows || {};

      return {
        ...state,
        expandedRows,
      };

    case types.START_JOB:
      let jobMap = state.jobMap;
      const newJob = action.job;
      newJob.updateRequired = true; //updateRequired - Deprecated, notification polls for updates.
      newJob.status = {};
      newJob.frequency = 750;
      jobMap = setIn(jobMap, [action.job.jobId], newJob);
      return {
        ...state,
        jobMap,
      };

    case types.UPDATE_JOB:
      const jobInfo = action.job;
      let jobMap3 = state.jobMap;
      const jobFrequency = getIn(jobMap3, [jobInfo.jobId, 'frequency']);
      const frequency = jobFrequency ? jobFrequency * 2.0 : 5000;
      jobMap3 = setIn(jobMap3, [jobInfo.jobId, 'message'], jobInfo.message);
      jobMap3 = setIn(jobMap3, [jobInfo.jobId, 'failed'], jobInfo.failed);
      jobMap3 = setIn(jobMap3, [jobInfo.jobId, 'complete'], jobMap3[jobInfo.jobId]?.complete || jobInfo.complete); //Don't permit 'undoing' job completion.
      jobMap3 = setIn(jobMap3, [jobInfo.jobId, 'recordCount'], jobInfo.recordCount);
      jobMap3 = setIn(jobMap3, [jobInfo.jobId, 'recordsProcessed'], jobInfo.recordsProcessed);
      jobMap3 = setIn(jobMap3, [jobInfo.jobId, 'recordsFailed'], jobInfo.recordsFailed);
      jobMap3 = setIn(jobMap3, [jobInfo.jobId, 'properties'], jobInfo.properties);
      jobMap3 = setIn(jobMap3, [jobInfo.jobId, 'childProgress'], jobInfo.childProgress);
      jobMap3 = setIn(jobMap3, [jobInfo.jobId, 'errorMessages'], jobInfo.errorMessages);
      if (!jobInfo.complete || !jobInfo.failed) {
        jobMap3 = setIn(jobMap3, [jobInfo.jobId, 'frequency'], frequency);
      }
      //Deprecated - 'updateRequired' only exists to support a handful of calls to the deprecated 'START_JOB' action, so we know
      //           - to dispatch a toast - These calls will eventually be replaced with 'dispatchJobToast' directly, making this defunct.
      jobMap3 = setIn(jobMap3, [jobInfo.jobId, 'updateRequired'], false);
      return {
        ...state,
        jobMap: jobMap3,
      };

    case types.COMPLETE_JOB:
      let jobMap4 = state.jobMap;
      jobMap4 = deleteIn(jobMap4, [action.job.jobId]);
      return {
        ...state,
        jobMap: jobMap4,
      };

    case types.FAIL_JOB:
      let jobMap8 = state.jobMap;
      jobMap8 = deleteIn(jobMap8, [action.job.jobId]);
      return {
        ...state,
        jobMap: jobMap8,
      };

    case types.BACKGROUND_JOB:
      let jobMap6 = state.jobMap;
      jobMap6 = setIn(jobMap6, [action.job.jobId, 'backgrounded'], true);
      return {
        ...state,
        jobMap: jobMap6,
      };

    case types.STORE_URL:
      return {
        ...state,
        returnURL: action.url,
      };

    default:
      if (state.autoFocus) {
        return {
          ...state,
          autoFocus: false,
        };
      }
      return state;
  }
}

export default reducer;
